module.exports = __webpack_public_path__ + "media/images/emoticons/seven-5b00fe922a73a358d26d2ede5415e3bc.gif";